var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offset-md-3 col-md-6 mt-5"},[_c('ChangePassword'),_c('div',{staticClass:"row border-bottom my-4"}),_c('ChangeName'),_c('div',{staticClass:"row border-bottom my-4"}),_c('ChangeIdCode'),_c('div',{staticClass:"row border-bottom my-4"}),_c('ChangeLanguage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }